import dayjs from "dayjs";
import {Row, Input} from "antd";
import React, {useState} from "react";
import CustomSelect from "../common/CustomSelect";

const AddDayField = ({ rows, handleSetRows, isUnixTime, hasTime, disabled }) => {
    const timeUnit = hasTime
        ? [
              { id: "DAY", name: "day" },
              { id: "HOUR", name: "hour" },
              { id: "MINUTE", name: "minute" },
          ]
        : [{ id: "DAY", name: "day" }];

    const [beforeEnd, setBeforeEnd] = useState(0);
    const [time, setTime] = useState(timeUnit[0]);
    const [addTime, setAddTime] = useState(0);

    const handleAddDays = (value) => {
        const numValue = Number(value);
        if (beforeEnd === 0) {
            setBeforeEnd(rows.end);
        }
        if (numValue <= 0) {
            setAddTime(0);
            handleSetRows("end", beforeEnd);
        } else if (numValue > 0) {
            setAddTime(numValue);
            isUnixTime
                ? handleSetRows(
                      "end",
                      time.name === "day"
                          ? dayjs.unix(rows.begin).endOf("day").add(numValue, time.name)
                          : dayjs.unix(rows.begin).add(numValue, time.name)
                  )
                : handleSetRows(
                      "end",
                      time.name === "day"
                          ? dayjs(rows.begin).add(numValue, time.name).endOf("day")
                          : dayjs(rows.begin).add(numValue, time.name)
                  );
        }
    };

    const handleSetTime = (key, value) => {
        setTime(value);
    };

    return (
        <Row className="add-day-field-root" align="middle" style={{ marginRight: 8 }}>
            <Input
                className={"add-time-field"}
                type="number"
                placeholder="AddTime"
                value={addTime}
                onChange={(e) => handleAddDays(e.target.value)}
                disabled={disabled}
                style={{ width: 80, marginRight: 8 }}
            />
            <CustomSelect
                items={timeUnit}
                value={time}
                label={"단위"}
                key={"time"}
                handleSet={handleSetTime}
                width={90}
                disabled={disabled}
            />
        </Row>
    );
};

export default AddDayField;